module.exports = __webpack_public_path__ + "static/media/potted.8e7afb6f.svg";